//React
import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as searchAction from '../action/searchAction';
import * as uiAction from '../action/uiAction';
//Func
import { lsSearchConditionInit } from '../func/lsSearchCondition';
import * as myPersonalityAction from '../action/myPersonalityAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import Slider from '@material-ui/core/Slider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
//Icon
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';


//Part
import PartCheckbox from './PartCheckbox';
import PartStarIcon from './PartStarIcon';
//Dialog
import DialogConfirm from './DialogConfirm';

//JSON
var profileItem = require('../data/profileItem.json');


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


class Comp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      age: [18, 90],
      distance: 0,
      proof: [],
      photo: [],
      recentSignin: false,
      postCheck: false,
      qaCheck: false,
      keyword: '',
      name: '',
      loginLimit: 90,
      region: [],
      marriage: [],
      job: [],
      academic: [],
      lifestyle: [],
      height: [120, 230],
      style: [],
      association: [],
      child: [],
      smorking: [],
      drinking: [],
      gambling: [],
      pet: [],
      blood: [],
      constellation: [],
      income: [],
      personality: [],
      opposite: [],
      conditionList: [],
      conditionListDelId: null,
      conditionSaveDialog: false,
      conditionSaveName: '',
  	}
  }



  componentDidUpdate(prevProps, prevState) {
    if (prevProps.open === false && this.props.open === true) {

      let lsObj = JSON.parse(localStorage.getItem('SearchCondition'));

      this.setState({
        age: [Number(lsObj.age.low), Number(lsObj.age.high)],
        distance: lsObj.distance,
        proof: lsObj.proof,
        photo: lsObj.photo,
        signinRecent: lsObj.signinRecent,
        postCheck: lsObj.postCheck,
        qaCheck: lsObj.qaCheck,
        keyword: lsObj.keyword,
        name: lsObj.name,
        loginLimit: lsObj.loginLimit,
        region: lsObj.region,
        marriage: lsObj.marriage,
        job: lsObj.job,
        academic: lsObj.academic,
        lifestyle: lsObj.lifestyle,
        height: [lsObj.height.low, lsObj.height.high],
        style: lsObj.style,
        association: lsObj.association,
        child: lsObj.child,
        smorking: lsObj.smorking,
        drinking: lsObj.drinking,
        gambling: lsObj.gambling,
        pet: lsObj.pet,
        blood: lsObj.blood,
        constellation: lsObj.constellation,
        income: lsObj.income,
        personality: lsObj.personality,
        opposite: lsObj.opposite,
      });

      this._searchConditionListGet();
    }
  }

  _searchConditionListGet() {
    this.props.searchConditionListGet();
  }


  _searchConditionDel() {
    this.props.searchConditionListGet();
  }


  _ageSelect() {
    let selectLow = [];
    let selectHigh = [];
    for (let i = 18; i <= 90; i++) {
      selectLow.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
    }
    for (let i = 90; i >= 18; i--) {
      selectHigh.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
    }
    return (
    <div>
      <div
        style={{
          display:'flex',
          flexDirection:'row',
          textAlign:'center',
          alignItems:'center',
          justifyContent: 'center'
        }}
      >
        <div>
          <FormControl variant="outlined">
            <Select
              value={this.state.age[0]}
              onChange={ (event) => this.setState({age:[event.target.value, this.state.age[1]]}) }
            >
              {selectLow}
            </Select>
          </FormControl>
        </div>
        <div>
          &nbsp;〜&nbsp;
        </div>
        <div>
          <FormControl variant="outlined">
            <Select
              value={this.state.age[1]}
              onChange={ (event) => this.setState({age:[this.state.age[0], event.target.value]}) }
            >
              {selectHigh}
            </Select>
          </FormControl>
        </div>
        <div>
          &nbsp;才
        </div>
      </div>
      <Slider
        value={this.state.age}
        onChange={ (e, value) => this.setState({age: value}) }
        valueLabelDisplay="auto"
        min={18}
        max={90}
        style={{width:'100%'}}
      />
    </div>
    );
  }

  _heightSelect() {
    let selectLow = [];
    let selectHigh = [];
    for (let i = 120; i <= 230; i++) {
      selectLow.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
    }
    for (let i = 230; i >= 120; i--) {
      selectHigh.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
    }
    return (
    <div>
      <div
        style={{
          display:'flex',
          flexDirection:'row',
          textAlign:'center',
          alignItems:'center',
          justifyContent: 'center'
        }}
      >
        <div>
          <FormControl variant="outlined">
            <Select
              value={this.state.height[0]}
              onChange={ (event) => this.setState({height:[event.target.value, this.state.height[1]]}) }
            >
              {selectLow}
            </Select>
          </FormControl>
        </div>
        <div>
          &nbsp;〜&nbsp;
        </div>
        <div>
          <FormControl variant="outlined">
            <Select
              value={this.state.height[1]}
              onChange={ (event) => this.setState({height:[this.state.height[0], event.target.value]}) }
            >
              {selectHigh}
            </Select>
          </FormControl>
        </div>
        <div>
          &nbsp;cm
        </div>
      </div>
      <Slider
        value={this.state.height}
        onChange={ (e, value) => this.setState({height: value}) }
        valueLabelDisplay="auto"
        min={120}
        max={230}
        style={{width:'100%'}}
      />
    </div>
    );
  }

  _regionChange(value) {
		if (!this.state.region.includes(value)) {
			this.setState({ region: [...this.state.region, value] });
		}
    else {
			this.setState({ region: this.state.region.filter((arr) => { return arr !== value }) });
		}
  }

  _checkboxChange(stateKey, value) {
		if (!this.state[stateKey].includes(value)) {
			this.setState({ [stateKey]: [...this.state[stateKey], value] });
		}
    else {
			this.setState({ [stateKey]: this.state[stateKey].filter((arr) => { return arr !== value }) });
		}
  }

  _submit(reset) {
    var obj = {
      age: {
        low: this.state.age[0],
        high: this.state.age[1],
      },
      distance: this.state.distance,
      proof: this.state.proof,
      photo: this.state.photo,
      signinRecent: this.state.signinRecent,
      postCheck: this.state.postCheck,
      qaCheck: this.state.qaCheck,
      keyword: this.state.keyword.replace(/[　]/g, " ").trim(),
      name: this.state.name.replace(/[ 　]/g, ""),
      loginLimit: this.state.loginLimit,
      region: this.state.region,
      marriage: this.state.marriage,
      job: this.state.job,
      academic: this.state.academic,
      lifestyle: this.state.lifestyle,
      height: {
        low: this.state.height[0],
        high: this.state.height[1],
      },
      style: this.state.style,
      association: this.state.association,
      child: this.state.child,
      smorking: this.state.smorking,
      drinking: this.state.drinking,
      gambling: this.state.gambling,
      pet: this.state.pet,
      blood: this.state.blood,
      constellation: this.state.constellation,
      income: this.state.income,
      personality: this.state.personality,
      opposite: this.state.opposite,
    };
    localStorage.setItem('SearchCondition', JSON.stringify(obj));
    this.props.onSubmit();
    this.props.onClose();
  }

  _resetSubmit() {
    lsSearchConditionInit();
    this.props.onSubmit();
    this.props.onClose();
  }

  _conditionSave() {
    let condition = {
      age: {
        low: this.state.age[0],
        high: this.state.age[1],
      },
      distance: this.state.distance,
      proof: this.state.proof,
      photo: this.state.photo,
      signinRecent: this.state.signinRecent,
      postCheck: this.state.postCheck,
      qaCheck: this.state.qaCheck,
      keyword: this.state.keyword.replace(/　/g, " ").trim(),
      name: this.state.name.replace(/[ 　]/g, ""),
      loginLimit: this.state.loginLimit,
      region: this.state.region,
      marriage: this.state.marriage,
      job: this.state.job,
      academic: this.state.academic,
      lifestyle: this.state.lifestyle,
      height: {
        low: this.state.height[0],
        high: this.state.height[1],
      },
      style: this.state.style,
      association: this.state.association,
      child: this.state.child,
      smorking: this.state.smorking,
      drinking: this.state.drinking,
      gambling: this.state.gambling,
      pet: this.state.pet,
      blood: this.state.blood,
      constellation: this.state.constellation,
      income: this.state.income,
      personality: this.state.personality,
      opposite: this.state.opposite,
    };
    this.props.searchConditionSave(this.state.conditionSaveName, condition);
    this.setState({conditionSaveDialog: false});
  }


  _loadCondition(index) {
    if (index === 'myProfile') {
      let myProfile = this.props.my.profile;
      this.setState({
        age: [Number(myProfile.userdata_prof_partner_age_low), Number(myProfile.userdata_prof_partner_age_high)],
        height: [Number(myProfile.userdata_prof_partner_height_low), Number(myProfile.userdata_prof_partner_height_high)],
        distance: 0,
        signinRecent: false,
        postCheck: false,
        qaCheck: false,
        proof: [],
        photo: [],
        marriage: this._conditionPrepare(myProfile.userdata_prof_partner_marriage),
        region: this._conditionPrepare(myProfile.userdata_prof_partner_region),
        job: this._conditionPrepare(myProfile.userdata_prof_partner_job),
        income: this._conditionPrepare(myProfile.userdata_prof_partner_income),
        academic: this._conditionPrepare(myProfile.userdata_prof_partner_academic),
        lifestyle: this._conditionPrepare(myProfile.userdata_prof_partner_lifestyle),
        style: this._conditionPrepare(myProfile.userdata_prof_partner_style),
        association: this._conditionPrepare(myProfile.userdata_prof_partner_association),
        child: this._conditionPrepare(myProfile.userdata_prof_partner_child),
        smorking: this._conditionPrepare(myProfile.userdata_prof_partner_smorking),
        drinking: this._conditionPrepare(myProfile.userdata_prof_partner_drinking),
        gambling: this._conditionPrepare(myProfile.userdata_prof_partner_gambling),
        pet: this._conditionPrepare(myProfile.userdata_prof_partner_pet),
        blood: [],
        constellation: [],
        keyword: '',
        name: '',
        loginLimit: 90,
        personality: [],
        opposite: [],
      });
    }
    else {
      let condition = this.props.searchCondition.list[index];
      this.setState({
        age: [Number(condition.ageLow), Number(condition.ageHigh)],
        height: [Number(condition.heightLow), Number(condition.heightHigh)],
        distance: Number(condition.distance),
        signinRecent: condition.signinRecent,
        postCheck: condition.postCheck,
        qaCheck: condition.qaCheck,
        proof: condition.proof,
        photo: condition.photo,
        marriage: condition.marriage,
        region: condition.region,
        job: condition.job,
        income: condition.income,
        academic: condition.academic,
        lifestyle: condition.lifestyle,
        style: condition.style,
        association: condition.association,
        child: condition.child,
        smorking: condition.smorking,
        drinking: condition.drinking,
        gambling: condition.gambling,
        pet: condition.pet,
        blood: condition.blood,
        constellation: condition.constellation,
        keyword: condition.keyword,
        name: condition.name,
        loginLimit: condition.loginLimit,
        personality: (this.props.my.personality.type16) ? condition.personality: [],
        opposite: condition.opposite,
      });
    }
    this.props.snackOpen('success', '条件を読み込みました', 3000);
  }

  _conditionPrepare(value) {
    if (value === '問わない' || value.length === 0) {
      value = [];
    }
    else {
      value = value.split(',')
    }
    return value;
  }

	render() {
		return (
    <Dialog
      fullScreen
      open={this.props.open}
      onClose={ () => this.props.onClose() }
      TransitionComponent={Transition}
      style={{maxWidth:'600px', margin:'auto'}}
    >
      <div style={{background:'#666'}}>
        <div style={{position:'fixed',top:'0',left:'0px',width:'100%' ,zIndex:'101'}}>
          <div style={{maxWidth:'600px', margin:'auto', background:'#FFF'}} className='shadow'>
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <IconButton
                  onClick={ () => this.props.onClose() }
                  >
                  <ArrowBackIosIcon />
                </IconButton>
                <span style={{fontSize:'1.1em',fontWeight:'bold'}}>検索条件</span>
              </div>
              <div style={{marginRight:'5px'}}>
                <Button
                  variant="outlined"
                  color='primary'
                  onClick={ () => this.setState({conditionSaveDialog: true}) }
                  size='small'
                >
                  条件を保存
                </Button>

                &nbsp;
                <Button
                  variant="outlined"
                  color='primary'
                  onClick={ () => this._resetSubmit() }
                  size='small'
                >
                  条件をリセット
                </Button>
              </div>
            </div>
          </div>
        </div>

  			<div
          style={{
            width:'100%',
            background:'#FFF',
            paddingTop:'40px',
            paddingBottom:'60px',
          }}
          className='shadow'
        >
          <div style={{padding:'3%'}}>
            <div style={{padding:'3%', lineHeight:'3em'}}>
              <Chip
                label={'プロフィールの希望条件から'}
                onClick={ () => this._loadCondition('myProfile') }
                variant="outlined"
                style={{margin:'5px'}}
              />
              {
                this.props.searchCondition.list.map(
                  (value, index) => {
                    return (
                      <Chip
                        key={index}
                        label={value.conditionName}
                        onClick={ () => this._loadCondition(index) }
                        onDelete={ () => this.setState({conditionListDelId: value.id }) }
                        deleteIcon={<ClearIcon />}
                        variant="outlined"
                        style={{margin:'5px'}}
                      />
                    )
                  }
                )
              }
            </div>
            <DialogConfirm
              open={ (this.state.conditionListDelId) ? true : false }
              title={'保存条件の削除'}
              content={　'保存条件を1件削除してもいいですか？' }
              apply={ () => {
                this.props.searchConditionDel(this.state.conditionListDelId);
                this.setState({conditionListDelId: null});
              }}
              close={ () => this.setState({conditionListDelId: null}) }
            />

            <div style={{padding:'3%'}}>
              <h3>
                年齢
              </h3>
              <div style={{textAlign:'center'}}>
                {
                  this._ageSelect()
                }
              </div>
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                距離
              </h3>

              {
                (this.state.distance === 0) ? (
                  <div>制限なし</div>
                ): (
                  <div>{this.state.distance} km圏内</div>
                )

              }
              <Slider
                value={this.state.distance}
                onChange={ (e, value) => this.setState({distance: value}) }

                min={0}
                max={200}
                step={10}
                style={{width:'100%'}}
              />
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                証明書
              </h3>
              {
                profileItem.proof.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.en}
                    checked={this.state.proof.includes(value.en)}
                    click={ (e) => this._checkboxChange('proof', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                写真
              </h3>
              {
                [{'ja':'メイン写真', 'en':'main'}, {'ja':'いずれかの写真', 'en':'sub'}].map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.en}
                    checked={this.state.photo.includes(value.en)}
                    click={ (e) => this._checkboxChange('photo', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                新着
              </h3>
              <PartCheckbox
                value={this.state.signinRecent}
                checked={this.state.signinRecent}
                click={ (e) => this.setState({signinRecent: (this.state.signinRecent ? false: true)}) }
              >
                <span>14日以内に入会した方</span>
              </PartCheckbox>

            </div>

            <div style={{padding:'3%'}}>
              <h3>
                コミュニティー
              </h3>
              <PartCheckbox
                value={this.state.postCheck}
                checked={this.state.postCheck}
                click={ (e) => this.setState({postCheck: (this.state.postCheck ? false: true)}) }
              >
                <span>投稿を記入している</span>
              </PartCheckbox>

              <PartCheckbox
                value={this.state.qaCheck}
                checked={this.state.qaCheck}
                click={ (e) => this.setState({qaCheck: (this.state.qaCheck ? false: true)}) }
              >
                <span>Q&Aを記入している</span>
              </PartCheckbox>

            </div>

            <div style={{padding:'3%'}}>
              <h3>
                キーワード
              </h3>
              <input
                value={this.state.keyword}
                onChange={ (e) => this.setState({keyword: e.target.value}) }
                style={{fontSize:'1.2em'}}
                className={ "input_blue round6" }
              />
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                ニックネーム
              </h3>
              <input
                value={this.state.name}
                onChange={ (e) => this.setState({name: e.target.value}) }
                style={{fontSize:'1.2em'}}
                className={ "input_blue round6" }
              />
            </div>


            <div style={{padding:'3%'}}>
              <h3>
                ログイン
              </h3>
              <FormControl variant="outlined">
                <Select
                  value={this.state.loginLimit}
                  onChange={ (event) => this.setState({loginLimit: event.target.value}) }
                >
                  {
                    profileItem.loginLimit.map((value, index) =>
                      <MenuItem key={index} value={value.en}>{value.ja}</MenuItem>
                    )
                  }
                </Select>
              </FormControl>
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                地域
              </h3>
              {
                profileItem.region.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.region.includes(value.ja)}
                    click={ (e) => this._checkboxChange('region', e) }
                  >
                    <span>{value.ja.replace(/(県)|(府)|(海外-)/g, "")}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                結婚歴
              </h3>
              {
                profileItem.marriage.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.marriage.includes(value.ja)}
                    click={ (e) => this._checkboxChange('marriage', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                収入
              </h3>
              {
                profileItem.income.map((value, index) =>
                  <div key={index}>
                    <PartCheckbox
                      value={value.ja}
                      checked={this.state.income.includes(value.ja)}
                      click={ (e) => this._checkboxChange('income', e) }
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  </div>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                仕事
              </h3>
              {
                profileItem.job.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.job.includes(value.ja)}
                    click={ (e) => this._checkboxChange('job', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                学歴
              </h3>
              {
                profileItem.academic.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.academic.includes(value.ja)}
                    click={ (e) => this._checkboxChange('academic', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                生活
              </h3>
              {
                profileItem.lifestyle.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.lifestyle.includes(value.ja)}
                    click={ (e) => this._checkboxChange('lifestyle', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                身長
              </h3>
              <div style={{textAlign:'center'}}>
                {
                  this._heightSelect()
                }
              </div>

            </div>

            <div style={{padding:'3%'}}>
              <h3>
                体型
              </h3>
              {
                profileItem.style.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.style.includes(value.ja)}
                    click={ (e) => this._checkboxChange('style', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                交際希望
              </h3>
              {
                profileItem.association.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.association.includes(value.ja)}
                    click={ (e) => this._checkboxChange('association', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                子供
              </h3>
              {
                profileItem.child.map((value, index) =>
                  <div key={index}>
                    <PartCheckbox
                      value={value.ja}
                      checked={this.state.child.includes(value.ja)}
                      click={ (e) => this._checkboxChange('child', e) }
                    >
                      <span>{value.ja}</span>
                    </PartCheckbox>
                  </div>
                )
              }
            </div>


            <div style={{padding:'3%'}}>
              <h3>
                タバコ
              </h3>
              {
                profileItem.smorking.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.smorking.includes(value.ja)}
                    click={ (e) => this._checkboxChange('smorking', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                お酒
              </h3>
              {
                profileItem.drinking.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.drinking.includes(value.ja)}
                    click={ (e) => this._checkboxChange('drinking', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                ギャンブル
              </h3>
              {
                profileItem.gambling.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.gambling.includes(value.ja)}
                    click={ (e) => this._checkboxChange('gambling', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                ペット
              </h3>
              {
                profileItem.pet.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.pet.includes(value.ja)}
                    click={ (e) => this._checkboxChange('pet', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                血液型
              </h3>
              {
                profileItem.blood.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.blood.includes(value.ja)}
                    click={ (e) => this._checkboxChange('blood', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                星座
              </h3>
              {
                profileItem.constellation.map((value, index) =>
                  <PartCheckbox
                    key={index}
                    value={value.ja}
                    checked={this.state.constellation.includes(value.ja)}
                    click={ (e) => this._checkboxChange('constellation', e) }
                  >
                    <span>{value.ja}</span>
                  </PartCheckbox>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                性格
              </h3>
              {
                (this.props.my.personality.type16) ? (
                  this.props.my.personality.relation.map((value, index) =>
                    <PartCheckbox
                      key={index}
                      value={value.type2}
                      checked={this.state.personality.includes(value.type2)}
                      click={ (e) => this._checkboxChange('personality', e) }
                    >
                      <div>
                        {value.type2}
                        <div><PartStarIcon count={value.stars} /></div>

                      </div>
                    </PartCheckbox>
                  )
                ) : (
                  <div>
                    <div>性格診断をすると、相性で検索できます</div>
                    <div>
                      <Link to='/my/personality/'>
                        <Button
                          color='primary'
                        >
                          <u>性格診断をする</u>
                        </Button>
                      </Link>
                    </div>
                  </div>
                )
              }
            </div>

            <div style={{padding:'3%'}}>
              <h3>
                思われ条件
              </h3>

              <div style={{color:'#666'}}>あなたのプロフィールを希望する方を検索します</div>
              <div style={{padding:'5px'}}>
                <Button
                  color='primary'
                  onClick={ () => {
                    let list = profileItem.opposite.map(function(value, index) {
                      return value.ja;
                    });
                    this.setState({opposite: list})
                  }}
                >
                  <u>すべてチェックする</u>
                </Button>
                <Button
                  color='primary'
                  onClick={ () => {
                    this.setState({opposite: []})
                  }}
                >
                  <u>すべてチェックはずす</u>
                </Button>
              </div>
              {
                profileItem.opposite.map((value, index) =>
                  <div key={index}>
                    <PartCheckbox
                      value={value.ja}
                      checked={this.state.opposite.includes(value.ja)}
                      click={ (e) => this._checkboxChange('opposite', e) }
                    >
                      <div>
                        {value.ja}
                        { (value.en === 'age' && (<span>({this.props.my.profile.userdata_age}才)</span>)) }
                        { (value.en === 'region' && (<span>({this.props.my.profile.userdata_prof_region})</span>)) }
                        { (value.en === 'height' && (<span>({this.props.my.profile.userdata_prof_height}cm)</span>)) }
                        { (value.en === 'academic' && (<span>({this.props.my.profile.userdata_prof_academic})</span>)) }
                        { (value.en === 'job' && (<span>({this.props.my.profile.userdata_prof_job})</span>)) }
                        { (value.en === 'income' && (<span>({this.props.my.profile.userdata_prof_income})</span>)) }
                        { (value.en === 'style' && (<span>({this.props.my.profile.userdata_prof_style})</span>)) }
                        { (value.en === 'association' && (<span>({this.props.my.profile.userdata_prof_association})</span>)) }
                        { (value.en === 'marriage' && (<span>({this.props.my.profile.userdata_prof_marriage})</span>)) }
                        { (value.en === 'child' && (<span>({this.props.my.profile.userdata_prof_child})</span>)) }
                        { (value.en === 'lifestyle' && (<span>({this.props.my.profile.userdata_prof_lifestyle})</span>)) }
                        { (value.en === 'smorking' && (<span>({this.props.my.profile.userdata_prof_smorking})</span>)) }
                        { (value.en === 'drinking' && (<span>({this.props.my.profile.userdata_prof_drinking})</span>)) }
                        { (value.en === 'gambling' && (<span>({this.props.my.profile.userdata_prof_gambling})</span>)) }
                        { (value.en === 'pet' && (<span>({this.props.my.profile.userdata_prof_pet})</span>)) }
                      </div>
                    </PartCheckbox>
                  </div>
                )
              }

            </div>
          </div>

          <div style={{position:'fixed',bottom:'0',left:'0px',width:'100%' ,zIndex:'101'}}>
            <div style={{maxWidth:'600px', margin:'auto', background:'rgba(0,0,0,0.3)'}}>
              <div style={{padding:'10px'}}>
                <Button
                  variant="contained"
                  color='primary'
                  onClick={ () => this._submit() }
                  style={{width: '100%', fontSize:'1.2em'}}
                >
                  会員検索する
                </Button>
              </div>
            </div>
          </div>

          <Dialog
            open={this.state.conditionSaveDialog}
          >
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent:'space-between',
              }}
            >
              <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
                条件に名前をつけてください
              </div>

              <IconButton
                onClick={ () => {this.setState({conditionSaveDialog:false, conditionSaveName:''}) }}
              >
                <CloseIcon/>
              </IconButton>
            </div>
            <div style={{padding:'10px'}}>
              1〜10文字
              <input
                className="input_blue round6"
                onChange={(e) => this.setState({ conditionSaveName: e.target.value})}
                value={this.state.conditionSaveName}
                style={{fontSize:'1.2em'}}
                maxLength={10}
              />
            </div>
            <div align='center' style={{padding:'10px'}}>
              <Button
                variant="contained"
                color="primary"
                style={{fontSize:'1.1em'}}
                onClick={ () => this._conditionSave() }
                disabled={ (this.state.conditionSaveName.length > 0 && this.state.conditionSaveName.length <= 10) ? false: true }
              >
                保存する
              </Button>
            </div>
          </Dialog>

        </div>
			</div>
    </Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
    searchCondition: state.searchCondition,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...searchAction,
    ...myPersonalityAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
